import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, DatePipe } from '@angular/common';
import { CryptoTransaction } from '../Models/crypto-transactions';

@Component({
  selector: 'odin-transaction-crypto-details',
  templateUrl: './transaction-crypto-details.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule
  ]
  ,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    table.table tr td {
      min-height: 1px !important;
      height: 48px;
      vertical-align: middle;
    }
    h1 {
      font-size: 1.3rem;
      font-weight: 600;
    }
    h2 {
      font-size: 1.1rem;
      font-weight: 400;
    }
    @media (max-width: 600px) {
      .px-3 { padding-left: 0.5rem !important; padding-right: 0.5rem !important; }
      table.table { font-size: 0.95rem; }
      h1 { font-size: 1.1rem; }
      h2 { font-size: 1rem; }
    }
  `]
})
export class TransactionCryptoDetailsComponent {
  constructor(
    public dialogRef: MatDialogRef<TransactionCryptoDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CryptoTransaction
  ) {}
}
